import '../../monitoring/filters/tag/applied_tags_view.js.coffee'
Namespace 'Profiling.Dashboard.Filters'

class Profiling.Dashboard.Filters.AppliedTagsView extends Monitoring.Views.SocialContents.Filters.AppliedTagsView
  initialize: ({searchQuery, title, tagsByClientCode}) ->
    super(
      searchQuery: searchQuery
      tagsByClientCode: tagsByClientCode
    )
    @title = title

  _triggerQueryChanged: =>
    @searchQuery.triggerFilterChanged()

  getTitle: =>
    @title
